import { useScrollReveal } from "../../../hooks/useScrollReveal";

export const BendWhatWeDo = () => {
  const [h1Ref, h1Vis] = useScrollReveal();
  const [mb1Ref, mb1Vis] = useScrollReveal(0.1);
  const [fb1Ref, fb1Vis] = useScrollReveal(0.1);

  return (
    <section
      id="what-we-do"
      data-testid="bend-what-we-do-section"
      className="bg-white py-28 md:py-40 lg:py-48"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-20">
        {/* Header */}
        <div ref={h1Ref} className={`reveal ${h1Vis ? 'visible' : ''}`}>
          <h2
            data-testid="bend-what-we-do-heading"
            className="font-['Playfair_Display'] font-semibold text-[clamp(36px,5vw,68px)] tracking-[-0.03em] text-[#0F172A] leading-[1.0]"
          >
            We do two things<br/>to scale your marketing.
          </h2>
        </div>

        {/* Stacked blocks */}
        <div className="mt-20 md:mt-28 space-y-0">
          {/* Media Buying */}
          <div
            ref={mb1Ref}
            data-testid="bend-media-buying-block"
            className={`grid md:grid-cols-[1fr,1.2fr] gap-8 md:gap-16 lg:gap-24 py-16 md:py-20 border-t border-[#E2E8F0] reveal ${mb1Vis ? 'visible' : ''}`}
          >
            <div>
              <h3 className="font-['Playfair_Display'] font-semibold text-[32px] md:text-[40px] lg:text-[48px] tracking-[-0.02em] text-[#0F172A] leading-[1.05]">
                Media Buying
              </h3>
              <div className="mt-5 flex flex-wrap gap-2">
                {["Meta", "Google", "TikTok", "YouTube"].map(p => (
                  <span key={p} className="text-[12px] font-semibold tracking-wide uppercase text-[#0064E0] bg-[#E5F0FF] px-3 py-1.5 rounded-full">
                    {p}
                  </span>
                ))}
              </div>
            </div>
            <div>
              <p className="text-[17px] md:text-[18px] leading-[1.7] text-[#475569]">
                We run your ads on Meta, Google, TikTok, and YouTube. Both of us
                are in the account every day, watching what's working and moving
                money toward it. Every call gets made by someone who's managed
                seven-figure ad budgets, not someone who started last month and
                is learning on your dime.
              </p>
            </div>
          </div>

          {/* Funnel Building */}
          <div
            ref={fb1Ref}
            data-testid="bend-funnel-building-block"
            className={`grid md:grid-cols-[1fr,1.2fr] gap-8 md:gap-16 lg:gap-24 py-16 md:py-20 border-t border-b border-[#E2E8F0] reveal ${fb1Vis ? 'visible' : ''}`}
          >
            <div>
              <h3 className="font-['Playfair_Display'] font-semibold text-[32px] md:text-[40px] lg:text-[48px] tracking-[-0.02em] text-[#0F172A] leading-[1.05]">
                Funnel Building
              </h3>
              <div className="mt-5 flex flex-wrap gap-2">
                {["Landing Pages", "Offer Structure", "CRO"].map(p => (
                  <span key={p} className="text-[12px] font-semibold tracking-wide uppercase text-[#0064E0] bg-[#E5F0FF] px-3 py-1.5 rounded-full">
                    {p}
                  </span>
                ))}
              </div>
            </div>
            <div>
              <p className="text-[17px] md:text-[18px] leading-[1.7] text-[#475569]">
                A good ad pointing at a bad page is just wasted money. So we
                rebuild the pages, offers, and booking steps behind your ads.
                Whether your customer books online, fills out a form, or picks
                up the phone, we clear out whatever's making them leave before
                they do.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
